import { BookFeature } from './book-feature';
import { Position } from './position';

export abstract class MoveableBookFeature extends BookFeature {

    position: Position;
    zIndex: number;
    isDeleted = false;

}
